import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./register.css";

export default function Register() {

  const [name, setName] = useState("");

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleRegister = () => {

    if (!name || !email || !password) {

      alert("Please fill all fields ❗");

      return;
    }

    axios.post(
      "https://apple2.shopat1stop.com/api/register",
      {
        name,
        email,
        password
      }
    )

    .then((res) => {

      alert(
        res.data?.message ||
        "Registered Successfully ✅"
      );

      setName("");
      setEmail("");
      setPassword("");

      navigate("/login");

    })

    .catch((err) => {

      alert(
        err.response?.data?.message ||
        "Error ❌"
      );

    });

  };

  return (

    <div className="register-page">

      <div className="register-card">

        {/* LEFT SIDE */}
        <div className="register-left">

          <h1>
            🍃 Apple Smoke Shop
          </h1>

          <p>
            Create your account and
            explore premium THCA,
            CBD, Gummies, Vapes &
            Smoke Essentials.
          </p>

        </div>

        {/* RIGHT SIDE */}
        <div className="register-right">

          <h2>
            Create Account 🚀
          </h2>

          <p className="register-subtitle">
            Join the premium smoke store
          </p>

          <input
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) =>
              setName(e.target.value)
            }
          />

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
          />

          <button
            onClick={handleRegister}
          >
            Create Account
          </button>

          <div className="register-links">

            <Link to="/login">
              Already have an account?
              Login
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}